import { render } from "./DepositDetails.vue?vue&type=template&id=1fed39ff"
import script from "./DepositDetails.vue?vue&type=script&lang=js"
export * from "./DepositDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__